var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { computed } from 'mobx';
import { BaseModel } from '../../libraries';
class UserModel extends BaseModel {
    // 单例模式 全局唯一
    constructor() {
        super();
        if (!lodash.isEmpty(UserModel.UserModel)) {
            return UserModel.UserModel;
        }
        this.onInit({
            type: 'object',
            storageKey: 'activity_user',
            storageLoading: false,
        });
        UserModel.UserModel = this;
    }
    /** token */
    get token() {
        return this.value.token;
    }
}
__decorate([
    computed
], UserModel.prototype, "token", null);
export function getUserModel() {
    return new UserModel();
}
